import { createContext, useContext } from "react";

import { ScoreType } from "@/types";

export type InsightFilters = {
  scoreType: ScoreType;
  levels: number[];
  searchText: string;
  sortType?: string;
};

export const InsightFiltersContext = createContext<
  | {
      filters: InsightFilters;
      setFilters: React.Dispatch<React.SetStateAction<InsightFilters>>;
    }
  | undefined
>(undefined);

export const useInsightFilters = () => {
  const context = useContext(InsightFiltersContext);
  if (!context) {
    throw new Error("useInsightFilters must be used within the context");
  }
  return context;
};
